export enum CustomDimension {
    Organisation = 1,
    EWCStatus = 3,
    AppName = 4
}
